import { Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { EmailTemplateType } from "@/types/email-templates";

interface CloneDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onClone: () => void;
  isCloning: boolean;
  templateType: EmailTemplateType;
  selectedAgentName?: string;
  selectedAgentId: string | null;
}

const CloneDialog = ({
  isOpen,
  onOpenChange,
  onClone,
  isCloning,
  templateType,
  selectedAgentName,
  selectedAgentId,
}: CloneDialogProps) => {
  const templateLabel =
    templateType === "conversation_report"
      ? "Conversation Report"
      : templateType === "meeting_recap"
        ? "Meeting Recap"
        : templateType === "escalation_alert"
          ? "Escalation Alert"
          : templateType === "conversation_digest"
            ? "Conversation Digest"
            : "Customer Report";

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Clone from Default Template</AlertDialogTitle>
          <AlertDialogDescription>
            This will create a copy of the default {templateLabel} template
            {selectedAgentId && ` for ${selectedAgentName}`}.
            {selectedAgentId && " We'll apply the agent's branding automatically."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onClone} disabled={isCloning}>
            {isCloning ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Cloning...
              </>
            ) : (
              "Clone Template"
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CloneDialog;
